import { FieldType } from '@/catalog/constants/fieldTypes';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';
import { FIRE } from '@/media/entity/SetupPreset';
import MetricMap from '@/metric/components/MetricMap/MetricMap';
import Diamond from '@/product/entity/Diamond';

export const FIELD_FIRE_MAP: Field = {
  label: 'Fire Map',
  fullLabel: 'Fire Map',
  key: 'fireMap',
  type: FieldType.Media,
  spGroupId: null,
  getValue(p) {
    return p instanceof Diamond ? (p.fireMetric?.map ?? null) : null;
  },
  getText() {
    return null;
  },
  render(p, { viewSettings, maxScale } = {}) {
    if (p instanceof Diamond && p.fireMetric && viewSettings) {
      return (
        <MetricMap
          aria-label="Fire map chart"
          isSingleScaleEnabled={viewSettings.resultedIsSingleScale}
          maxScale={maxScale}
          mediaSize={viewSettings.mediaSize!}
          metric={p.fireMetric}
          product={p}
          setupPresetId={FIRE}
        />
      );
    }

    return null;
  },
  contexts: ALL_CONTEXTS,
};
